module.exports = __webpack_public_path__ + "images/cac88fb0d5927f36268ba2adbd34b5b006cf7634d68a39f190a99055f706a3a6.svg";